<template>
    <mc-modal
        v-model="visible"
        title="相似度商品列表"
        width="80%"
        :closable="false"
        destroy-on-close
    >
        <div v-if="localData && localData.length">
            <div class="title">
                <i
                    class="mtdicon-warning-circle"
                    style="color: red;"
                ></i>
                <span>{{ '系统检测到相似商品，请确认是否同品，可智能填充商品信息' }}</span>
            </div>
            <!-- 默认展示top5的数据 -->
            <mc-table-pro
                ref="table"
                name="table"
                :pagination="false"
                :columns="columns"
                :source="expanding ? localData : localData.slice(0, 5)"
            >
                <template
                    slot="codeList"
                    slot-scope="{row}"
                >
                    {{ (row.codeList || []).map((item) => item.code).join(',') }}
                </template>
                <template
                    slot="mainPictureList"
                    slot-scope="{row}"
                >
                    <mc-image
                        v-for="(pic, index) in row.mainPictureList.map((item) => item.picUrl)"
                        :key="pic"
                        style="width: 100px; height: 100px; margin-right: 10px; display: inline-block;"
                        :src="pic"
                        :preview-url-list="row.mainPictureList.map((item) => item.picUrl)"
                        :preview-first-index="index"
                    />
                </template>
                <template
                    slot="operation"
                    slot-scope="{row}"
                >
                    <mc-button
                        type="primary"
                        @click="handleConfirm(row)"
                    >
                        是同品
                    </mc-button>
                </template>
            </mc-table-pro>
            <mc-button
                v-if="localData && localData.length > 5"
                type="text"
                class="expand-button"
                @click="() => expanding = !expanding"
            >
                {{ expanding ? '收起' : '展开查看更多' }}
            </mc-button>
        </div>
        <div
            slot="footer"
            style="text-align: center;"
        >
            <mc-button
                type="primary"
                @click="handleCancel"
            >
                都不是，新建
            </mc-button>
        </div>
    </mc-modal>
</template>

<script>
import {
    defineComponent, ref,
} from '@vue/composition-api';
import { reportLx } from '@lsfe/tools';

// 表格列
const columns = [
    {
        label: '序号',
        type: 'index',
        width: 80,
    },
    {
        label: '相似度',
        prop: 'similarity',
        formatter: (row) => (row.similarity ? `${(+row.similarity * 100).toFixed(2)}%` : '--'),
    },
    {
        label: '商品名称',
        prop: 'cspuName',
    },
    {
        label: '条形码',
        prop: 'codeList',
    },
    {
        label: '图片',
        prop: 'mainPictureList',
        width: 360,
    },
    {
        label: '操作',
        prop: 'operation',
    },
];
// attrs字段中属性字段与属性id的映射
const attrsMap = {
    brandId: 1000000,
    spec: 1000002,
};

export default defineComponent({
    name: 'SimilarCspuModal',
    setup(props, { emit }) {
        const visible = ref(false);
        const localData = ref([]);
        const expanding = ref(false); // 表格是否处于展开状态

        const popup = (list) => {
            visible.value = true;
            // 最多展示50条数据
            localData.value = (list || []).map((item) => ({
                similarity: item.similarity,
                ...(item.cspuWithAttr || {}), // 将cspu信息字段展开
                /**
                 * 特殊处理的字段
                 */
                mainPictureList: (item.cspuWithAttr?.mainPictureList || []).slice(0, 3), // 只保留前3张图片
                /**
                 * 将cspuWithAttr中字段名称与提报表单中的字段名称对齐，方便赋值
                 */
                skuName: item.cspuWithAttr?.cspuName || '',
                brandId: item.cspuWithAttr?.attrs?.find((attr) => attr.id === attrsMap.brandId)?.values?.map((child) => child.id)?.[0] || '',
                specActual: item.cspuWithAttr?.attrs?.find((attr) => attr.id === attrsMap.spec)?.values?.map((child) => child.value)?.[0] || '',
            })).slice(0, 50);
        };
        const cspuInfoTrack = (cspuId) => {
            reportLx('moduleClick',
                'b_chaoshi_jwn0g9eg_mc',
                {
                    cspuid: cspuId,
                }, {
                    cid: 'c_chaoshi_nfuxc185',
                });
        };
        const handleCancel = () => {
            visible.value = false;
            localData.value = [];
        };
        const handleConfirm = (row) => {
            emit('confirm', row);
            cspuInfoTrack();
            handleCancel();
        };

        return {
            columns,
            visible,
            localData,
            expanding,
            popup,
            handleCancel,
            handleConfirm,
        };
    },
});
</script>

<style lang="scss" scoped>
.expand-button {
    text-align: center;
    width: 100%;
    margin-top: 5px;
}
</style>
